import styles from "./Footer.module.css";
import { toast } from "react-toastify";
function Footer() {
  const warning = () =>
    toast.warn("Sorry, this feature is still under development");
  return (
    <footer>
      <div className={styles.footer + " row me-0"}>
        <div className={styles.left_section + " col-12 col-md-4"}>
          <h2 className={styles.left_subtitle}>Let's stay in touch!</h2>
          <p>Loop in for the latest news and get the best deals!</p>
          <div className="input-group mb-3">
            <input
              type="text"
              className={"form-control " + styles.subscription}
              placeholder="Email"
              aria-label="Email"
              aria-describedby="button-addon2"
            />
            <button
              className={"btn  " + styles.btn_subscription}
              type="button"
              id="button-addon2"
              onClick={warning}
            >
              Subscribe
            </button>
          </div>
        </div>
        <div className={styles.middle_section + " col-12 col-md-4"}>
          <div className="row me-0">
            <div className="col-6 p-0 m-0">
              <h4 className={styles.middle_subtitle}>CUSTOMER SERVICE</h4>
              <ul className="list-unstyled text-start">
                <li className={styles.footer_li}>FAQ's</li>
                <li className={styles.footer_li}>Contact Us</li>
                <li className={styles.footer_li}>Product Registration</li>
                <li className={styles.footer_li}>Warranty</li>
              </ul>
            </div>
            <div className="col-6 p-0 m-0">
              <h4 className={styles.middle_subtitle + " text-end"}>
                INFORMATION
              </h4>
              <ul className="list-unstyled text-end">
                <li className={styles.footer_li}>Brand story</li>
                <li className={styles.footer_li}>Team</li>
                <li className={styles.footer_li}>Sustainability</li>
                <li className={styles.footer_li}>Career</li>
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.right_section + " col-12 col-md-4 text-center"}>
          <h3 className={styles.right_subtitle + " p-0 m-0"}>WE ARE KSURF</h3>
          <p>
            At KSURF, we understand the unbreakable bond between the elements
            and our tribe. We too feel the pull. This is Kiteboarding! This is
            Foiling. It calls.
          </p>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
